import { observable, action, decorate } from "mobx";

/*
 * Open/closed state for the agents side panel on the right rail. It docks
 * beside the page exactly like the copilot drawer, and the two share the same
 * slot next to the rail -- so opening one closes the other (see RightRail and
 * AgentsPanel).
 */
class AgentsPanelStore {
  open = false;

  setOpen = value => {
    this.open = !!value;
  };

  toggle = () => {
    this.open = !this.open;
  };

  close = () => {
    this.open = false;
  };
}

decorate(AgentsPanelStore, {
  open: observable,
  setOpen: action,
  toggle: action,
  close: action
});

const agentsPanelStore = new AgentsPanelStore();
export default agentsPanelStore;
